export default "__VITE_PUBLIC_ASSET__6e448efe__"